// extracted by mini-css-extract-plugin
export default {"container":"Scroll_container__2Xlim","main":"Scroll_main__QXEPy","scroll":"Scroll_scroll__K2tDY"};